import { Button, ButtonLink } from "design-system/atoms/Button"
import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { ArrowRight, AudioLines } from "lucide-react"
import { useCampaignQuery } from "modules/campaigns/hooks/useCampaignQuery"
import { Loading } from "modules/shared/components/Loading"
import { useState } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  campaignId: string
}

export function KnowledgeBaseCampaignInfo({ campaignId }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()
  const { data: campaign } = useCampaignQuery(campaignId, { enabled: isOpen })

  return (
    <Tooltip open={isOpen && !!campaign} onOpenChange={setIsOpen}>
      <TooltipTrigger asChild>
        <Button type="button" variant="ghost" size="icon" className="cursor-default">
          <AudioLines className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent className="flex flex-col items-center gap-1 p-2" side="right">
        {campaign && (
          <>
            <p>{t("knowledge.form.campaignInfo.title", { campaignName: campaign.name })}</p>
            <ButtonLink
              to="/campaigns/$id/knowledge-base"
              size="sm"
              variant="secondary"
              className="w-fit"
              params={{ id: campaignId }}
            >
              <span>{t("knowledge.form.campaignInfo.viewCampaign")}</span>
              <ArrowRight className="w-4 h-4" />
            </ButtonLink>
          </>
        )}
        {!campaign && <Loading />}
      </TooltipContent>
    </Tooltip>
  )
}
